module.exports = __webpack_public_path__ + "index/img/haibao.c4e93a41.png";